export const ADD_SLIDE = 'ADD_SLIDE'
export const EDIT_SLIDE = 'EDIT_SLIDE'
export const DELETE_SLIDE = 'DELETE_SLIDE'
export const EDIT_SETTINGS = 'EDIT_SETTINGS'
export const UPDATE_SYNC_STATE = 'UPDATE_SYNC_STATE'

// Used for pouchdb-middleware plugin
export const INSERT_SLIDE = 'INSERT_SLIDE'
export const UPDATE_SLIDE = 'UPDATE_SLIDE'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js